import { useSelector } from "react-redux";
import { HOME, LOGIN } from "../../routes/routes_name";
import { loginData } from "../../stores/auth";
import { Navigate } from "react-router-dom";

const decodeJWT = (token) => {
    try {
        const base64Payload = token.split('.')[1];
        const payload = atob(base64Payload.replace(/-/g, '+').replace(/_/g, '/'));
        return JSON.parse(payload);
    } catch {
        return null;
    }
};

const hasRole = (roles = [], roleCode) => {
    return roles.some(
        (r) => r.kode_aplikasi === "account" && r.kode_role === roleCode
    );
};

const ProtectedRoute = ({ children, isLogin, isRole1, isRole2 }) => {
    const dataLogin = useSelector(loginData);

    // 🔐 LOGIN GUARD
    if (isLogin && !dataLogin.isLogin) {
        return <Navigate to={LOGIN} replace />;
    }

    if (!isLogin && dataLogin.isLogin) {
        return <Navigate to={HOME} replace />;
    }

    // 🎭 ROLE GUARD
    if (isRole1 || isRole2) {
        const token = dataLogin.token_account;
        if (!token) return <Navigate to={HOME} replace />;

        const decoded = decodeJWT(token);
        const roles = decoded?.roles || [];

        const role1 = hasRole(roles, "1");
        const role2 = hasRole(roles, "2");

        // 🔥 KEY CHANGE: OR logic instead of AND
        const allowed =
            (isRole1 && role1) ||
            (isRole2 && role2);

        if (!allowed) {
            return <Navigate to={HOME} replace />;
        }
    }

    return children;
};

export default ProtectedRoute;
